@if (visible) {
  <div class="file-viewer-container" style="position: relative">
    <!-- Loading spinner -->
    @if (loading()) {
      <div class="loading-container">
        <p-progressSpinner styleClass="custom-spinner" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
        <div class="loading-text">{{ 'survey.pdf.viewer.loading.document' | translate }}</div>
      </div>
    }
    <!-- PDF Viewer -->
    @if (isPdf() && fileUrl) {
      <div class="pdf-container">
        <pdf-viewer
          [src]="fileUrl"
          [render-text]="renderText"
          [original-size]="originalSize"
          [show-all]="showAll"
          [autoresize]="autoresize"
          [fit-to-page]="fitToPage"
          [zoom]="zoom"
          [rotation]="rotation"
          [external-link-target]="externalLinkTarget"
          [show-borders]="false"
          (error)="onError($event)"
          (after-load-complete)="onPdfLoaded($event)"
        ></pdf-viewer>
      </div>
    }
    <!-- Office Viewer -->
    @if (isOffice()) {
      <iframe
        width="100%"
        height="100%"
        title="File viewer"
        [src]="getOfficeViewerUrl() | safeUrl"
        sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-presentation allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
        (load)="onIframeLoad()"
      ></iframe>
    }
    <!-- Unsupported Viewer -->
    @if (!isPdf() && !isOffice()) {
      <div class="unsupported-message">
        {{ 'file.viewer.unsupported' | translate }}
        @if (downloadable) {
          <a [href]="fileUrl" target="_blank" rel="noopener">
            {{ 'file.viewer.download' | translate }}
          </a>
        }
      </div>
    }
    <!-- } -->
  </div>
}
